import { useSyncExternalStore } from 'react'

/**
 * Какую сборку клиента сервер назвал в последнем ответе (заголовок `X-Client-Build`, его ставит nginx входа на каждый
 * ответ). Опроса сервера нет: любой запрос приложения — это и проверка версии. Хранится вне Redux: это не данные
 * сервера и не намерение человека, а сигнал для плашки обновления.
 */
let current: string | null = null
const listeners = new Set<() => void>()

/** Вызывается транспортом на каждом ответе с заголовком. */
export function reportServerBuild(buildId: string): void {
  if (buildId === current) return
  current = buildId
  for (const listener of listeners) listener()
}

/** Только для тестов: забыть сигнал предыдущего сценария. */
export function resetServerBuild(): void {
  current = null
  for (const listener of listeners) listener()
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function useServerBuild(): string | null {
  return useSyncExternalStore(subscribe, () => current)
}
